import type { RegionKey } from '@artifax/shared';

/**
 * Auto-detect the visitor's region from their browser timezone. Ported from
 * the design prototype's `_detect`. Falls back to US.
 */
export function detectRegion(): RegionKey {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    if (/Toronto|Halifax|Winnipeg|Edmonton|Vancouver|Regina|St_Johns|Moncton|Iqaluit|Whitehorse/.test(tz))
      return 'CA';
    if (/Europe|Africa|Asia|Atlantic|Madrid|Paris|Berlin|London/.test(tz)) return 'EU';
    if (/America|US|Pacific|Honolulu|Anchorage|Denver|Chicago|New_York|Los_Angeles/.test(tz))
      return 'US';
  } catch {
    /* ignore */
  }
  return 'US';
}
